(function (angular) {
    'use strict';
    angular
        .module('app.sod')
        .config([
            '$stateProvider', 
            '$urlRouterProvider', 
            summaryOfDiscountRoutes
        ]);

    function summaryOfDiscountRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.sod', {
                url: '/summary-of-discounts',
                templateUrl: '/app/site/summary-of-discounts/summary-of-discounts.template.html',
                controller: 'app.sod.controller',
                controllerAs: 'vm'
            })
            .state('app.sodplus', {
                url: '/summary-of-discountsplus',
                templateUrl: '/app/site/summary-of-discounts/summary-of-discounts.template.html',
                controller: 'app.sod.controller',
                controllerAs: 'vm'
            });
    }
    
})(angular);